import { AxiosPromise } from 'axios';
import { default as Resource } from 'src/services/api-client/resource/base/Resource';

export default class ConstantsResource extends Resource {
    constructor( ) {
        super('');
    }

    public indexMaritalStatuses(): AxiosPromise {
        this.getHeaders();
        return this.httpClient
            .get('/marital-statuses/')
            .catch((errorResponse) => {
                throw errorResponse;
            });
    }

    public indexEconomicStatuses(): AxiosPromise {
        this.getHeaders();
        return this.httpClient
            .get('/economic-statuses/')
            .catch((errorResponse) => {
                throw errorResponse;
            });
    }

    public indexTypeStatuses(): AxiosPromise {
        this.getHeaders();
        return this.httpClient
            .get('/type-statuses/')
            .catch((errorResponse) => {
                throw errorResponse;
            });
    }

    public indexProfessions(): AxiosPromise {
        this.getHeaders();
        return this.httpClient
            .get('/professions/')
            .catch((errorResponse) => {
                throw errorResponse;
            });
    }

    public indexSectorsOfInterest(): AxiosPromise {
        this.getHeaders();

        return this.httpClient
            .get('/sectors-of-interest/')
            .catch((errorResponse) => {
                throw errorResponse;
            });
    }
}



// WEBPACK FOOTER //
// ./src/services/api-client/resource/ConstantsResource.tsx